
import { useHead } from '@vueuse/head'
import CixDash from './cix/CixDash.vue'
import SidebarLayout from '../layouts/SidebarLayout.vue'
import { computed, defineComponent, reactive } from 'vue'
import VButton from '../components/base/button/VButton.vue'
import { mapState } from 'vuex'

export default defineComponent({
  name: 'CixPage',
  components: {
    VButton,
    CixDash,
    SidebarLayout
  },
  setup() {
    const siteData = reactive({
      title: 'CIX Formula Parser'
    })
    useHead({
      title: computed(() => siteData.title),
    })
  },
  computed: {
    ...mapState(['user'])
  }
})
